module.exports = __webpack_public_path__ + "assets/img/customerService-c1b57180.png";